import { ShoppingCardIcon } from '@assets/images';
import { ReactElement } from 'react';
import { TableRow } from '@app/common/DataTable/types';
import {
  FlexRow,
  LastUpdatedRow,
  ListRow,
  NameRow,
  TestTypeRow,
} from '../styles';
import {
  dateTime24FriendlyFormatWithComma,
  formatUTCStringAsApiTimestamp,
} from '@app/utils';
import { NullableNumber } from '@app/common/types';
import { getTestTypeLabel } from '../utils';

type OrderRowI = {
  row: TableRow;
  onClick: (id: NullableNumber) => void;
};

const OrderRow = ({ row, onClick }: OrderRowI): ReactElement => {
  const dateTime = formatUTCStringAsApiTimestamp(
    (row.bookedDate as unknown) as number,
    dateTime24FriendlyFormatWithComma
  );

  return (
    <ListRow onClick={() => onClick((row.id as unknown) as NullableNumber)}>
      <FlexRow>
        <ShoppingCardIcon />
        <NameRow>{`${row.firstName} ${row.lastName}`}</NameRow>
      </FlexRow>
      <FlexRow>
        <TestTypeRow>
          {getTestTypeLabel(
            (row.testType as unknown) as string,
            (row.testCategory as unknown) as string
          )}
        </TestTypeRow>
        <LastUpdatedRow>{dateTime}</LastUpdatedRow>
      </FlexRow>
    </ListRow>
  );
};

export default OrderRow;
